import {connect} from "react-redux";
import * as InfoActions from '../../store/actions/infoActions';
import * as AuthActions from '../../store/actions/authActions';
import OnBoarding from "../../components/onBoarding/OnBoarding";
import * as AppActions from '../../store/actions/appActions';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    getProfile: (profileId, token) => {
        dispatch(AuthActions.getProfile(profileId, token));
    },
    hideLoader: () => {
        dispatch(AppActions.appLoading(false));
    },
    updateProfile: (profile, token) => {
        dispatch(InfoActions.updateProfile(profile, token));
    },
    updateCourseUser: (profile, cu, token) => {
        dispatch(InfoActions.updateCourseUser(profile, cu, token));  
    },
    onBasicInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateBasicUserInfo(update, token));
    },
    onContactsInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateContactsUserInfo(update, token));
    },
    onEducationInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateEducationUserInfo(update, token));
    },
    onCircumstancesInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateCircumstancesUserInfo(update, token));
    },
    getCourseUserForProfile: (cuId, token) => {
        dispatch(AuthActions.getCourseUserForProfile(cuId, token));
    },
    onLsatInfoUpdate: (update, token) => {
        dispatch(InfoActions.updateLsatUserInfo(update, token));
    },
    addOfficialTest: (test, token) => {
        dispatch(AuthActions.updateOfficialTest(test, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OnBoarding);


// WEBPACK FOOTER //
// ./src/containers/OnBoarding/OnBoardingContainer.js